module.exports = __webpack_public_path__ + "media/images/underline-white-3cee43bf.svg";